import { BillingMethodEnum } from "@enums/billingMethodEnum.enum";
import { OpenItemsActionEnum } from "@enums/openItemsActionEnum.enum";

export class RemovePricingRequest {
    openItemsAction: OpenItemsActionEnum;
    shouldKeepAuth: boolean;
    invoiceItemIds: number[];
    userIds: string [];
    BillingMethod: BillingMethodEnum;
}
